import LanguageSingleton from "@/js/Shared/Language/Language";

export {MessageAttachmentsItem as default};

/**
* Message Recipient Item
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessageAttachmentsItem {
  /**
   * Attachment Id
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  id;

  /**
   * Attachment Imap id
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  muid;

  /**
   * Attachment Name
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  name;

  /**
   * Attachment download url
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  download;

  /**
   * Attachment preview url
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  preview_url;

  /**
   * Attachment thumbnail url
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {string}
   */
   thumbnail_url;

  /**
   * Attachment size
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
  size = 0;

  /**
   * Attachment Files Count
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
  files_count = 0;

  /**
   * Attachment File Type
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  type;

  /**
   * Attachment Target
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String} INTERNAL, SAPO_TRANSFER, MEO_CLOUD
   */
  target;

  /**
   * Content Attachment
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {HTMLImageElement|String}
   */
  contents = null;

  /**
   * HTML Related attributes
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Array}
   */
  related = [];

  /**
   * HTML Related id
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  related_id;

  /**
   * Attachment fetching state
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Boolean}
   */
  fetching = false;

  /**
   * Returns a size String representation
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  get size_text () {
    if (!this.size) {
      return LanguageSingleton.say('global.size_unknown');
    }

    const k     = 1024;
    const dm    = 2;
    const sizes = ['Bytes', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'];

    const i = Math.floor(Math.log(this.size) / Math.log(k));

    return `${parseFloat((this.size / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }
}